export var BreadcrumbsTheme = function (theme) { return ({
    defaultProps: {},
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                ol: {
                    flexWrap: "nowrap",
                },
                '.MuiTypography-root': {
                    fontWeight: "normal",
                },
                li: {
                    ' > .MuiButton-text ': {
                        height: 26,
                        minWidth: 0,
                        fontSize: theme.typography.body3.fontSize,
                        fontWeight: 500,
                        paddingLeft: theme.spacing(0.5),
                        paddingRight: theme.spacing(0.5),
                        '.MuiTypography-root': {
                            fontWeight: "500",
                        },
                        '> span:not(.MuiButton-startIcon):not(.MuiButton-endIcon )': {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }
                    },
                    '> .MuiLink-root': {
                        display: "block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                    },
                },
            });
        },
    },
}); };
export default BreadcrumbsTheme;
//# sourceMappingURL=theme.js.map